import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { MultiInput } from '../../MultiInput'
import { MultiInputClientValidator } from '../../MultiInput/validation'
import { BIN_SUB_FORM_NAME } from './BINEditor'
import { messages } from './messages'
import { validationSuite } from './validation'
import { BIN } from 'typings'

type Props = {
  state: FormState
}

export function BINField({ state }: Props) {
  const intl = useIntl()
  const { formatMessage: i18n } = intl

  const values: BIN = useWatch({ form: state, name: BIN_SUB_FORM_NAME })
  const validation = useMemo(() => validationSuite(intl), [intl])

  const restrictsInvalidCodes: MultiInputClientValidator = (input: string) => {
    const validationResult = validation(input)

    return validationResult.isValid()
      ? { valid: true }
      : { valid: false, message: validationResult.errors[0].message as string }
  }

  return (
    <MultiInput
      name="bin"
      values={values}
      onChange={(values) => state.setValue(BIN_SUB_FORM_NAME, values)}
      inputValidation={restrictsInvalidCodes}
      maxEntries={LIMITS.MAX_BINS}
      label={i18n(messages.binField.label)}
    />
  )
}
